import { useEffect, useRef, useState } from 'react';

const useMaxWidthForEllipsisWithTooltip = <T extends HTMLElement = HTMLElement>(columnWidth?: number | string) => {
  const container = useRef<T | null>(null);
  const [maxWidth, setMaxWidth] = useState(0);

  useEffect(() => {
    if (container.current) {
      setMaxWidth(container.current?.offsetWidth || 0);
    }
  }, [columnWidth, container.current]);

  return { container, maxWidth };
};

export default useMaxWidthForEllipsisWithTooltip;
